import React from 'react'

const Error = () => {
  return (
    <div className='container'>
      <h1 className='my-5 text-danger text-center'>Oops...</h1>
      <h2 className='text-danger-emphasis text-center'>Go Back</h2>
    </div>
  )
}

export default Error
